import type React from 'react';

import { Grid } from '@change/ds-layout';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageHeading } from '../components/PageHeading';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<>
			<PageBanner />
			<Grid className="mt-4 px-0 pb-4 lg:max-w-[1216px] lg:grid-cols-14!">
				<div className="col-span-full">
					<PageHeading />
					<PageBody />
				</div>
			</Grid>
			<PageFooter />
		</>
	);
};
